import { Step1WritingMode } from '../types/step1Writing';
import { t } from '../i18n/translate';

export function modeLabel(mode?: Step1WritingMode): string {
  if (!mode) return t('step.1.mode.not_chosen');
  switch (mode) {
    case 'external':
      return t('step.1.mode.external');
    case 'upload':
      return t('step.1.mode.upload');
    case 'typed':
      return t('step.1.mode.typed');
    case 'wizard':
      return t('step.1.mode.wizard');
    default:
      return t('step.1.mode.fallback');
  }
}

export function venueLabel(venue: string | undefined): string {
  switch (venue) {
    case 'workshop':
      return t('step.1.venue.workshop');
    case 'home_meeting':
      return t('step.1.venue.home_meeting');
    case 'sponsor_only':
      return t('step.1.venue.sponsor_only');
    case 'other':
      return t('step.1.venue.other');
    default:
      return '';
  }
}
